import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import {Link, useParams} from "react-router-dom";
import styled from "styled-components";
import {getForIndividualsComment} from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import CustomTable from "../../Common/DataTable/DataTable";
import { isAllValuesEmpty } from "../../../Utills/objectUtils";

export default function ViewComments() {
  const { partnerId, id } = useParams();
  const [isLoading, setIsLoading] = useState(true);


const [data,SetComment] = useState({
});
console.log("data ==> ", data);


const fetchComments = async () => {
  setIsLoading(true);
  if (!Number(id)) {
    setIsLoading(false);
    return;
  }

  try {
    const res = await getForIndividualsComment(id);
    const commentData = res.data.data[0];
    SetComment({ ...commentData, index: res.data.data.indexOf(commentData) });             
    console.log(commentData);                     
  } catch (err) {
    console.log(err);
  } finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  fetchComments();
}, [id]);


const columns = ["Comment owner", "Comment"];
const rows = [];

if (  data  && Object.keys(data).length > 0 && !isAllValuesEmpty(data)) {
  rows.push([data.owner_name1, data.comment1]);
  rows.push([data.owner_name2, data.comment2]);
  rows.push([data.owner_name3, data.comment3]);
  rows.push([data.owner_name4, data.comment4]);
}

  return (
    <>{isLoading ? <CmsCircularProgress/> :  
    <ContentWrapper>
      <HomeTitle>Comments Section</HomeTitle>
      <CustomTable columns={columns} rows={rows} isLoading={isLoading}/>
      <ButtonWrapper>
        <Link to={`/${partnerId}/forindividuals`}>
          <Button variant="secondary">Go Back</Button>
        </Link>
        <Link to={`/${partnerId}/forindividuals/comments/edit/${id}`}>
          <Button>Edit comment section</Button>
        </Link>
      </ButtonWrapper>
    </ContentWrapper>
}</>
   
  );
}

const ContentWrapper = styled.div`
 @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
  justify-content: center;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;

const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 5rem;
  justify-content: center;
  @media (max-width: 890px) {
    justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
    gap: 1rem;
  }
`;
